import { useFeatureFlagEnabled } from 'posthog-js/react';
import { PropsWithChildren } from 'react';

export const FeatureFlagged = (
  props: PropsWithChildren<{ name: string; visibleWhen?: boolean }>
) => {
  const { visibleWhen = true, name } = props;
  const flag = useFeatureFlagEnabled(name);
  console.log({ flag, name, visibleWhen });

  if (flag === visibleWhen) return props.children;

  return null;
};
